import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LocationByAttributeGQL } from '@cpd-app/generated';
import { map } from 'rxjs/operators';

import { Location as LocationAttribute } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class LifestyleService {
  constructor(private locationByAttributeGQL: LocationByAttributeGQL) {}

  public getSuggestedLocations(
    highVeteranPopulation: boolean,
    lowCostOfLiving: boolean,
    affordableHousing: boolean,
    lowUnemployment: boolean,
    highAirQuality: boolean,
    lowCrimeRate: boolean,
    highDemandFor: boolean,
    onetCode: string
  ): Observable<LocationAttribute[]> {
    // "Jobs in demand" with no job picked yet has nothing to rank by, but the
    // other options chosen with it still do (#36, walkthrough 29 Sep): only
    // when it is the one option chosen is there nothing to suggest.
    const othersChosen =
      highVeteranPopulation ||
      lowCostOfLiving ||
      affordableHousing ||
      lowUnemployment ||
      highAirQuality ||
      lowCrimeRate;
    if (highDemandFor && onetCode === 'undefined' && !othersChosen) {
      return of([]);
    }

    return this.locationByAttributeGQL
      .fetch({
        onetCodeDemand: onetCode || null,
        highVetPercent: highVeteranPopulation,
        lowCostOfLiving,
        affordableRealEstate: affordableHousing,
        lowUnemployment,
        goodAirQuality: highAirQuality,
        lowCrimeRate
      })
      .pipe(
        map((result) => {
          return result.data.locationByAttribute.map((l) => {
            return {
              costOfLiving: l.costOfLiving,
              crimeRate: l.crimeRate,
              demand: l.demand,
              fipsCode: parseInt(l.fipsCode),
              housingCostIndex: l.housingCostIndex,
              lat: l.lat,
              lon: l.lon,
              name: l.name,
              pctOfGoodAirQualityDays: l.pctOfGoodAirQualityDays,
              unemploymentRate: l.unemploymentRate,
              veteranPopulation: l.veteranPopulation
            };
          });
        })
      );
  }
}
